export const TOGGLE_LODDING = 'TOGGLE_LOADING'